<template>
    <div class="vote-strength-label">
        <icon-label
            :show-icon="showIcon"
            :show-label="showLabel"
            :size="size"
            :icon="{ type: 'circle', fill: vote.color, strokeWidth: '0', sizePercentage: 65 }"
            :label="vote.label" />
    </div>
</template>

<script setup>
import IconLabel from '@/common/icon-label/icon-label.vue';
import { IMPORTANCES } from '@/voc/constants/constants';
import { computed } from 'vue';

const props = defineProps({
    voteStrength: {
        type: Number,
        required: true,
    },
    size: {
        type: String,
        default: 'medium',
        validator: (value) => ['small', 'medium', 'large', 'xlarge'].includes(value),
    },
    showIcon: {
        type: Boolean,
        default: false,
    },
    showLabel: {
        type: Boolean,
        default: false,
    },
});

const vote = computed(() => IMPORTANCES.find((importance) => importance.id === props.voteStrength));
</script>

<style scoped>
.vote-strength-label {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
